<template>
    <div>
        <b-card header-tag="header">
            <template #header>
                qAssess Student Login
            </template>
            <b-card-text>
                <p class="loginBanner">{{loginBanner}}</p>
                <b-form>
                    <b-form-group
                        id="input-group-1"
                        label="Enter Access Code:"
                        label-for="input-accessCode"
                        description=""
                    >
                    <b-form-input
                        id="input-accessCode"
                        v-model="accessCode"
                        type="text"
                        required
                        placeholder="____-____-____"
                        v-mask="'NNNN-NNNN-NNNN'"
                        autofocus
                        v-on:input="accessCodeError = null"
                        ></b-form-input>
                    </b-form-group>
                    <div class="text-danger" v-if="accessCodeError != null">
                        <div>{{ accessCodeError }}</div>
                    </div>            
                </b-form>
            </b-card-text>
            <b-button variant="info" @click.prevent="login" class="mt-2" ref="btnLogin">Login</b-button>
        </b-card>
        <p><small>Authorized students only.  All activity is logged.</small></p>
    </div>
</template>

<script>

export default {
    name: 'Login',
    data() {
        return {        
            accessCode: null,
            accessCodeError: null,
            loginBanner: process.env.VUE_APP_LOGIN_BANNER
        }
    },
    methods: {  
        login() {
            let ac = replaceAll(this.accessCode.trim(), '-', '');
            if (ac.length == 0) {
                this.accessCodeError = "Access Code is required";
                return false;                
            }
            else if (ac.length != 12) {
                this.accessCodeError = "Access Code must be 12 characters";
                return false;
            }                

            this.$refs.btnLogin.innerText = "Logging in...";

            this.$http
                .post('/auth/login', { accessCode: ac } )
                .then(() => {
                    this.$router.push({ name: 'Home' });
                })
                .catch(error =>  {
                    if (error.response.status == 422) {
                        this.accessCodeError = "Invalid Access Code"
                    }
                    this.$refs.btnLogin.innerText = "Login";
                });
        }
    }
}

function replaceAll(str, match, replacement){
   return str.replace(new RegExp(match, 'g'), ()=>replacement);
}
</script>

<style scoped>
    .loginBanner {
        font-size: 1.2rem;
        font-weight: bold;
    }
    .card {
        margin: 100px auto 50px auto;
        width: 400px;
    }
    .card-header {
        background-color: black;
        color: white;
        font-weight: bold;
        font-size: 1.3rem;
    }
    .card-body {
        background-color: #f7f7f7;
        color: #000;
    }
    #input-accessCode {
        font-family: 'Courier New', Courier, monospace;
        width: 250px;
        margin: 0 auto;
        font-size: 1.6rem;
        padding: 0.5rem 0.5rem;
    }
    ::placeholder { 
        color: #B0B0B0;
        opacity: 1; 
    }    
</style>